import styles from "./radioGroup.module.scss";
import {
  Controller,
  FieldValues,
  UseControllerProps
} from "react-hook-form";

type RadioGroupProps<T extends FieldValues> = {
  options: Array<OptionItem>;
  disabled?: boolean;
} & UseControllerProps<T>

type OptionItem = {
  title: string;
  value: string;
}

export const RadioGroup = <T extends FieldValues>({ name, options, disabled, control }: RadioGroupProps<T>) => {

  return (
    <Controller
      name={name}
      control={control}
      disabled={disabled}
      render={({ field }) => (
        <div className={styles.container}>
          {options.map((option, index) => (
            <div className={styles.option} key={index}>
              <div className={styles.title}>{option.title}</div>
              <input className={styles.input}
                     type="radio"
                     value={option.value}
                     checked={field.value === option.value}
                     onChange={() => field.onChange(option.value)}
                     disabled={disabled}
              />
              <span className={styles.radioCustom}></span>
            </div>
          ))}
        </div>
      )}/>

  );
}